import React, { useState } from "react";
import { useTranslation } from "../../../contexts/TranslationContext";
import { CodeBracketIcon, DocumentDuplicateIcon } from "@heroicons/react/24/outline";

interface FormEmbedCodeProps {
  formId: number | undefined;
  apiBaseUrl: string;
}

const FormEmbedCode: React.FC<FormEmbedCodeProps> = ({ formId, apiBaseUrl }) => {
  const { t } = useTranslation();
  const [showEmbedPanel, setShowEmbedPanel] = useState(false);

  const copyJavaScriptEmbed = () => {
    const jsEmbedCode = `<!-- Add this div where you want the form to appear -->
<div id="ps-form-${formId}" 
     data-ps-form="${formId}" 
     data-ps-base-url="${apiBaseUrl}">
</div>

<!-- Include the embedding script -->
<script src="${apiBaseUrl}/form/builder.js"></script>`;
    navigator.clipboard.writeText(jsEmbedCode);
    alert("JavaScript embed code copied to clipboard!");
  };

  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium text-gray-900 flex items-center">
            <CodeBracketIcon className="h-5 w-5 mr-2 text-gray-500" />
            {t("forms.detail.embedCode.title")}
          </h3>
          <button
            onClick={() => setShowEmbedPanel(!showEmbedPanel)}
            className="text-sm text-primary-600 hover:text-primary-700"
          >
            {showEmbedPanel
              ? t("forms.detail.embedCode.hideInstructions")
              : t("forms.detail.embedCode.showInstructions")}
          </button>
        </div>

        {showEmbedPanel && (
          <div className="space-y-4">
            <p className="text-sm text-gray-600">
              {t("forms.detail.embedCode.embedDescription")}
            </p>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t("forms.detail.embedCode.javascriptFormBuilder")}
              </label>
              <div className="relative">
                <textarea
                  readOnly
                  value={`<!-- Add this div where you want the form to appear -->
<div id="ps-form-${formId}" 
     data-ps-form="${formId}" 
     data-ps-base-url="${apiBaseUrl}">
</div>

<!-- Include the embedding script -->
<script src="${apiBaseUrl}/form/builder.js"></script>`}
                  className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 sm:text-sm font-mono bg-gray-50"
                  rows={8}
                />
                <button
                  onClick={copyJavaScriptEmbed}
                  className="absolute top-2 right-2 inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50"
                >
                  <DocumentDuplicateIcon className="h-4 w-4 mr-1" />
                  {t("forms.detail.embedCode.copy")}
                </button>
              </div>
            </div>
            <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
              <p className="text-sm text-blue-800">
                <strong>{t("common.note")}:</strong>{" "}
                {t("forms.detail.embedCode.embedNote")}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormEmbedCode;

